// @flow
import React, { useCallback } from 'react';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { get } from 'lodash';
import classnames from 'classnames';
import { useTranslationNs, openSupportChat } from '@helpers/helpers';
import { router } from '@router';
import { Button, Icon } from '@elements';
import { isStoreReview } from '../../../redux/modules/appVersion';
import './BlockedFeature.scss';

// Subscriptions that are running: the plans page would only send them on to Meu Plano
const PAYING = ['active', 'past_due', 'will_cancel'];

type Props = {
  className?: string,
  customMessage?: string,
  customButton?: string,
  hint?: string | Function,
  hideUpgradeButton?: boolean,
  simpleStyle?: boolean,
  removeBg?: boolean,
  iconSize?: number,
  iconName?: string,
  // Before "Fazer Upgrade" goes to the plans, e.g. to count the taps
  onUpgrade?: Function,
};
const BlockedFeature = ({
  className, customMessage, hideUpgradeButton, customButton, hint, simpleStyle,
  iconSize, iconName, removeBg, onUpgrade,
}: Props) => {
  const history = useHistory();
  const subscriptionStatus = useSelector((state) => get(state, ['context', 'user', 'advancedData', 'subscriptionStatus']));
  // "Fazer Upgrade": an account that pays changes its plan from Meu Plano, the others pick one in the plans.
  // A custom button (talk to support) opens the chat.
  const onBtnClick = useCallback(() => {
    if (customButton) {
      openSupportChat();
      return;
    }
    if (onUpgrade) onUpgrade();
    history.push(router.getRoutePath(PAYING.includes(subscriptionStatus) ? 'subscriptionInfo' : 'pricing'));
  }, [customButton, history, subscriptionStatus, onUpgrade]);

  const [_] = useTranslationNs('global');
  // An iOS build in App Store review: no "Fazer Upgrade", it invites to buy. A custom button (support) stays.
  const storeReview = useSelector(isStoreReview);

  const cssClasses = classnames(['blockedFeature', className, { simpleStyle, removeBg }]);

  return (
    <div className={cssClasses}>
      <Icon iconName={iconName || 'lock'} className="icon" size={iconSize || 500} />
      <h2>{customMessage || _('label/blocked_feature')}</h2>
      {hint && <h3>{typeof hint === 'function' ? hint() : hint}</h3>}
      {!hideUpgradeButton && (customButton || !storeReview) && <Button className="primary" text={customButton || _('action/blocked_feature_upgrade')} onClick={onBtnClick} />}
    </div>
  );
};

export default BlockedFeature;
